export default "__VITE_ASSET__5f42cf5d__"